import React from "react";

import { SVGSprite } from "../../../../components/Atoms";
import { useWindowDimensions } from "../../../../hooks";
import Lottie from "react-lottie";
import playAnimation from "./play.json"
// import dynamic from "next/dynamic";

// const playAnimation = dynamic(() =>
//   import("./play.json").then(
//     (module) => module.playAnimation
//   ),
//   { ssr: false }
// );
import {
  OverlayContent,
  StyledAction,
  StyledButton,
  StyledVideoOverlay,
} from "./style";

const VideoOverlay = ({ thumbnail, onCLickHandler, showLottie = false }) => {
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: playAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <StyledVideoOverlay
      className="videoOverlay"
      bgImg={thumbnail && `url(${thumbnail})`}
    >
      <OverlayContent>
        <StyledAction>
          <StyledButton variant="link" onClick={onCLickHandler}>
            {showLottie ?
              <Lottie
                options={defaultOptions}
                height={"116px"}
                width={"116px"}
                isClickToPauseDisabled={true}
              />
              : <SVGSprite
                icon="icon-play-video"
                height={isMobile ? "60px" : "120px"}
                width={isMobile ? "60px" : "120px"}
              />
            } 
          </StyledButton>
        </StyledAction>
      </OverlayContent>
    </StyledVideoOverlay>
  );
};

export default VideoOverlay;
